<template>
  <div>
    <NBar title="会员卡用户统计" :top="true"/>
    <nut-textinput class="my-input" v-model="search" placeholder="请输入微信昵称/会员ID/手机" :clearBtnPersonnal="true">
      <template v-slot:clearBtn>
        <nut-icon type="cross"></nut-icon>
      </template>
    </nut-textinput>
    <nut-row>
      <nut-col :span="8" style="display: flex;align-items: center;">
        <div class="list">
          <span ref="title1" @click="isVisible1 = true">{{list1[0].text}}</span>
          <img :src="require('../../../../resource/img/device/svg/arrow-down.svg')" style="width: 20px;height: 20px;">
        </div>
        <nut-menu
          :is-animation="true"
          :isVisible="isVisible1"
          :list="list1"
          type="simple"
          @close="switchMenu(1)"
          @choose="(item,index)=> chooseMenu(item,index,list1,1)">
        </nut-menu>
        <div style="height: 20px;width: 1px;background-color: #D4D4D4;"></div>
      </nut-col>
      <nut-col :span="8" style="display: flex; align-items: center;">
        <div class="list">
          <span ref="title2" @click="isVisible2 = true">{{list2[0].text}}</span>
          <img :src="require('../../../../resource/img/device/svg/arrow-down.svg')" style="width: 20px;height: 20px;">
        </div>
        <nut-menu
          :isVisible="isVisible2"
          :list="list2"
          type="simple"
          @close="switchMenu(2)"
          @choose="(item,index)=> chooseMenu(item,index,list2,2)">
        </nut-menu>
        <div style="height: 20px;width: 1px;background-color: #D4D4D4;"></div>
      </nut-col>
      <nut-col :span="8">
        <div class="list">
          <span ref="title3" @click="isVisible3 = true">{{list3[0].text}}</span>
          <img :src="require('../../../../resource/img/device/svg/arrow-down.svg')" style="width: 20px;height: 20px;">
        </div>
        <nut-menu
          :isVisible="isVisible3"
          :list="list3"
          type="simple"
          @close="switchMenu(3)"
          @choose="(item,index)=> chooseMenu(item,index,list3,3)">
        </nut-menu>
      </nut-col>
    </nut-row>
    <nut-infiniteloading @loadmore="onInfinite" :is-show-mod="true" :has-more="isHasMore" :is-loading="isLoading"
                         :threshold="200" class="infiniteloading">
      <div class="count">
        <div class="top-item" style="border-right: 1px solid #f0f0f0;">
          <span class="value">0</span>
          <span class="text">会员用户</span>
        </div>
        <div class="top-item">
          <span class="value">0</span>
          <span class="text">会员用户</span>
        </div>
      </div>
      <nut-cell v-for="(item,index) in list" :key="index" :show-icon="true" class="item" @click-cell="goDetail()">
          <span slot="title">
            <span class="name">美妍堂美容养生会所（林子）</span>
            <img class="label-img" :src='require("@/resource/img/device/pe-icon.648d0799.png")'/>
          </span>
        <span slot="sub-title">ID:434642432<span style="margin-left: 5px">女</span></span>
        <div slot="avatar">
          <img class="img-icon" :src='require("@/resource/img/device/crown_icon.b2bcf611.png")'/>
        </div>
        <div slot="desc" class="desc">
          <span class="text">累计充值246.99元</span>
          <span>余额<span class="price">49.04元</span>，余币<span class="price">49.04个</span></span>
        </div>
      </nut-cell>
    </nut-infiniteloading>
  </div>
</template>

<script>
export default {
  name: 'MemberCountDetail',
  data () {
    return {
      list: [{
        name: '测试',
        phone: '18507316674',
        provinceName: '广东',
        cityName: '深圳',
        areaName: '宝安区',
        address: '新港同创汇'
      }, {
        name: '测试',
        phone: '18507316674',
        provinceName: '广东',
        cityName: '深圳',
        areaName: '宝安区',
        address: '新港同创汇'
      }, {
        name: '测试',
        phone: '18507316674',
        provinceName: '广东',
        cityName: '深圳',
        areaName: '宝安区',
        address: '新港同创汇'
      }, {
        name: '测试',
        phone: '18507316674',
        provinceName: '广东',
        cityName: '深圳',
        areaName: '宝安区',
        address: '新港同创汇'
      }, {
        name: '测试',
        phone: '18507316674',
        provinceName: '广东',
        cityName: '深圳',
        areaName: '宝安区',
        address: '新港同创汇'
      }, {
        name: '测试',
        phone: '18507316674',
        provinceName: '广东',
        cityName: '深圳',
        areaName: '宝安区',
        address: '新港同创汇'
      }, {
        name: '测试',
        phone: '18507316674',
        provinceName: '广东',
        cityName: '深圳',
        areaName: '宝安区',
        address: '新港同创汇'
      }],
      page: 2,
      num: 5,
      isHasMore: true,
      isLoading: false,
      isErr: false,
      timer: null,
      isVisible1: false,
      isVisible2: false,
      isVisible3: false,
      list1: [
        {
          id: 0,
          text: '全部状态',
          selected: true
        },
        {
          id: 1,
          text: '使用中',
          selected: false
        },
        {
          id: 2,
          text: '已过期',
          selected: false
        }
      ],
      list2: [
        {
          id: 0,
          text: '全部类型',
          selected: true
        },
        {
          id: 1,
          text: '折扣卡',
          selected: false
        },
        {
          id: 2,
          text: '月卡',
          selected: false
        },
        {
          id: 3,
          text: '季卡',
          selected: false
        }, {
          id: 4,
          text: '年卡',
          selected: false
        }
      ],
      list3: [
        {
          id: 0,
          text: '交易产地',
          selected: true
        }, {
          id: 1,
          text: '广州增城恒大酒店',
          selected: false
        }, {
          id: 2,
          text: '星港同创汇天璇座',
          selected: false
        }, {
          id: 3,
          text: '风暴健身',
          selected: false
        }, {
          id: 4,
          text: '小羊羔工作室女人花',
          selected: false
        }, {
          id: 5,
          text: '女人花',
          selected: false
        }, {
          id: 6,
          text: '丽聪美容',
          selected: false
        }
      ],
    }
  },
  methods: {
    onInfinite () {
      this.isLoading = true
      this.timer = setTimeout(() => {
        if (this.page <= 5) {
          let list = [{
            name: '测试',
            phone: '18507316674',
            provinceName: '广东',
            cityName: '深圳',
            areaName: '宝安区',
            address: '新港同创汇'
          }, {
            name: '测试',
            phone: '18507316674',
            provinceName: '广东',
            cityName: '深圳',
            areaName: '宝安区',
            address: '新港同创汇'
          }, {
            name: '测试',
            phone: '18507316674',
            provinceName: '广东',
            cityName: '深圳',
            areaName: '宝安区',
            address: '新港同创汇'
          }]
          for (let i in list) {
            this.list.push(list[i])
          }
          this.page = this.page + 1
        } else {
          this.isHasMore = false
        }
        this.isLoading = false
      }, 100)
    },
    switchMenu (num) {
      switch (num) {
        case 1:
          this.isVisible1 = false
          break
        case 2:
          this.isVisible2 = false
          break
        case 3:
          this.isVisible3 = false
          break
      }
    },
    chooseMenu (item, index, list, num) {
      this.switchMenu(num)
      list.map((value, key) => value.selected = false)
      this.$set(list[index], 'selected', true)
      this.$refs[`title${num}`].innerText = item.text
    },
  }
}
</script>

<style scoped>
  .list {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    position: relative;
    justify-content: center;
    min-height: 35px;
    width: 99%;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    text-decoration: none;
    -webkit-tap-highlight-color: transparent;
    outline: none;
    background-color: #fff;
    background-image: -webkit-gradient(linear, left top, left bottom, from(hsla(0, 0%, 85.5%, .5)), to(hsla(0, 0%, 85.5%, .5)));
    background-image: -o-linear-gradient(hsla(0, 0%, 85.5%, .5), hsla(0, 0%, 85.5%, .5));
    background-image: linear-gradient(hsla(0, 0%, 85.5%, .5), hsla(0, 0%, 85.5%, .5));
    background-size: 100% 1px;
    background-repeat: no-repeat;
  }

  .infiniteloading {
    padding: 0  20px;
    margin-top: 15px;
  }

  .infiniteloading .count {
    display: flex;
    flex-direction: row;
    align-items: center;
    background: #fff;
  }

  .infiniteloading .count .top-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    padding: 15px 0;
  }

  .infiniteloading .count .top-item .value{
      font-size: 20px;
  }

  .infiniteloading .count .top-item .text{
    color: #a3a3a3;
    margin-top: 5px;
  }

  .infiniteloading .item {
    padding: 10px;
  }

  .infiniteloading .item .label-img {
    width: 38px;
    height: 16px;
  }

  .infiniteloading .img-icon {
    width: 50px;
    height: 50px;
    margin-right: 10px;
  }

  .infiniteloading .item .name {
    display: inline-block;
    white-space: nowrap;
    width: 105px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .infiniteloading .item .desc {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-right: 5px;
  }

  .infiniteloading .item .desc .text {
    color: #585858;
  }

  .infiniteloading .item .desc .price {
    color: #ff9f00;
  }

  /deep/ .nut-textinput.my-input input {
    height: 36px;
    margin: 10px 15px;
    border-radius: 20px;
    padding-left: 40px;
    padding-right: 40px;
    background: url("data:image/svg+xml;charset=utf-8,%3Csvg version='1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath d='M15.8 14.3l-3.3-3.1c1-1.1 1.6-2.6 1.6-4.1 0-3.6-3.1-6.6-7-6.6s-7 3-7 6.6c0 3.6 3.1 6.6 7 6.6 1.7 0 3.2-.6 4.4-1.5l3.3 3.1c.1.1.3.2.5.2s.4-.1.5-.2c.3-.3.3-.7 0-1zM1.5 7.1c0-2.9 2.5-5.2 5.6-5.2 3.1 0 5.6 2.3 5.6 5.2 0 2.9-2.5 5.2-5.6 5.2-3.2 0-5.6-2.3-5.6-5.2z' fill-rule='evenodd' clip-rule='evenodd' fill='%23999'/%3E%3C/svg%3E") no-repeat 10px;
    background-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/member/MemberCountDetail.vue